export const isUserRoute = (pathname: string): boolean => pathname.indexOf('/admin') === -1;
